import api from '@/plugins/axios'

export interface MenuItemResponse {
  nome: string
  path: string
  icon: string
  secao: string
  ordem: number
}

export interface PaginaDisponivel {
  rota: string
  nome: string
  icone: string
  secao: string
  ordem: number
}

export interface PerfilPermissaoResponse {
  permissaoId: number
  perfilId: number
  perfilNome: string
  rota: string
  nomePagina: string
  icone: string
  secao: string
  ordem: number
}

export interface PermissaoItemRequest {
  rota: string
  nomePagina: string
  icone: string
  secao: string
  ordem: number
}

class PermissaoService {
  private readonly baseUrl = '/permissao'

  async getMenu(perfilIds: number[]): Promise<MenuItemResponse[]> {
    const { data } = await api.get(`${this.baseUrl}/menu`, {
      params: { perfilIds: perfilIds.join(',') },
    })
    return data
  }

  async getRotasPermitidas(perfilIds: number[]): Promise<string[]> {
    const { data } = await api.get(`${this.baseUrl}/rotas`, {
      params: { perfilIds: perfilIds.join(',') },
    })
    return data
  }

  async findByPerfil(perfilId: number): Promise<PerfilPermissaoResponse[]> {
    const { data } = await api.get(`${this.baseUrl}/perfil/${perfilId}`)
    return data
  }

  async getPaginasDisponiveis(): Promise<PaginaDisponivel[]> {
    const { data } = await api.get(`${this.baseUrl}/paginas`)
    return data
  }

  async salvarPermissoes(perfilId: number, permissoes: PermissaoItemRequest[]): Promise<void> {
    await api.post(this.baseUrl, { perfilId, permissoes })
  }
}

export default new PermissaoService()
